import React from 'react';

import Link from '~/components/core/Atomic/Link/Link';
import Caption from '~/components/core/TextComponents/Caption';
import { useCms } from '~/components/hooks/useCms';
import useOrganization from '~/components/OrganizationContext';
import { isoDateToUs } from '~/DateTimeUtils';
import type { ContactFullModel } from '~/server_shared/swagger/data-contracts';

interface COIPropsType {
  contact: ContactFullModel;
}

const COI: React.FC<COIPropsType> = ({ contact }) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { organizationContactRolesDict } = useOrganization();
  const { userOrganization } = useCms();

  if (!organizationContactRolesDict[contact.role].is_coi_required) {
    return null;
  }

  const getDescription = () =>
    contact.coi_expiration ? `COI - Expires ${isoDateToUs(contact.coi_expiration)}` : 'COI';

  return (
    <div className="mt-12 rounded bg-slate-200 p-12">
      <Caption variant={Caption.VARIANTS.LABEL}>COI</Caption>
      <div>
        {contact.coi_contact_document_id ? (
          <Link
            className="font-medium text-teal-600 underline"
            href={`/api/v1/organizations/${userOrganization.id}/contacts/${contact.id}/coi`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {getDescription()}
          </Link>
        ) : (
          <>-</>
        )}
      </div>
    </div>
  );
};

export default COI;
